import { useState } from "react";
import { api } from "../../api/api.js";

const ModalDocumentoTemplate = ({ isOpen, onClose, onTemplateCriado }) => {
  const [formData, setFormData] = useState({
    titulo: "",
    tipo: "",
    googleDriveFileId: ""
  });
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.titulo || !formData.tipo || !formData.googleDriveFileId) {
      alert("Por favor, preencha todos os campos obrigatórios.");
      return;
    }

    setLoading(true);
    try {
      const response = await api.post("/documentos/templates", formData);
      alert("Modelo cadastrado com sucesso!");
      
      // Reseta o formulário e recarrega a lista no componente pai
      setFormData({ titulo: "", tipo: "", googleDriveFileId: "" });
      onTemplateCriado(response.data);
      onClose();
    } catch (error) {
      const msg = error.response?.data?.erro || "Erro ao salvar modelo.";
      alert("Erro: " + msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-editar-wide">
        <div 
          className="modal-header-editar"
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}
        >
          <h2>CRIAR NOVO TEMPLATE</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: "1rem" }}>
            <label>Título do Documento <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="titulo"
              value={formData.titulo}
              onChange={handleChange}
              placeholder="Ex: Procuração Ad Judicia"
              required
              style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
            />
          </div>

          <div className="form-group" style={{ marginBottom: "1rem" }}>
            <label>Tipo do Documento <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tipo"
              value={formData.tipo}
              onChange={handleChange}
              placeholder="Ex: procuracao, contrato, declaracao"
              required
              style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
            />
          </div>

          <div className="form-group" style={{ marginBottom: "1.5rem" }}>
            <label>ID do Arquivo no Google Drive <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="googleDriveFileId"
              value={formData.googleDriveFileId}
              onChange={handleChange}
              placeholder="Ex: 1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgvE2upms"
              required
              style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
            />
            <small style={{ color: "#666", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>
              Instruções para a criação de documentos:
            </small>
            <small style={{ color: "#666", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>
              1º - Crie o documento no Drive (não apenas anexe documento em formato ".doc");
            </small>
            <small style={{ color: "#666", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>
              2º - Compartilhe o documento com este email: advger@advger.iam.gserviceaccount.com
            </small>
            <small style={{ color: "#666", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>
              3º - Copie o link do documento e abra em outra aba 
            </small>
            <small style={{ color: "#666", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>
              4º - Copie o "ID" do documento. Ex.: "https://docs.google.com/document/d/<strong>1todc9jGQwDTMiDNkvOlBB7S6nPtvFI2PW28</strong>/edit?tab=t.0"
            </small>
            <small style={{ color: "#666", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>
              4º - Cole no campo ID DO ARQUIVO 
            </small>
          </div>

          <div style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}>
            <button
              type="submit"
              className="btn-salvar"
              style={{ backgroundColor: "#28a745" }}
              disabled={loading}
            >
              {loading ? <span className="spinner-loader"></span> : "Salvar Template"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="btn-salvar"
              style={{ backgroundColor: "#6c757d" }}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalDocumentoTemplate;